/* Search-specific delegation: works before/after predictive-search DOM replacement. */
(() => {
  if (window.__neowareSearchDeals) return;
  window.__neowareSearchDeals = true;
  const KEY = 'neoware_wishlist';
  let active = null;
  const wishlist = () => { try { const v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v.map(String) : []; } catch { return []; } };
  function sync() {
    const ids = wishlist();
    document.querySelectorAll('[data-nsc-wishlist-toggle]').forEach(b => {
      const on = ids.includes(b.dataset.productId);
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', String(on));
      b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }
  function status(root, message) {
    let el = root.querySelector('[data-nsc-status]');
    if (!el) { el = document.createElement('p'); el.dataset.nscStatus = ''; el.setAttribute('role', 'status'); root.append(el); }
    el.textContent = message;
  }
  async function add(button, id, root) {
    if (!id || button.disabled) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      const base = window.Shopify?.routes?.root || '/';
      const response = await fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: String(id), quantity: 1 }] }) });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to add this item. Please try again.');
      status(root, 'Added to cart');
      const cartResponse = await fetch(base + 'cart.js');
      if (cartResponse.ok) {
        const cart = await cartResponse.json();
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'search-deals', data: { itemCount: cart.item_count } } }));
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { source: 'search-card', items: data.items } }));
    } catch (error) { status(root, error.message || 'Unable to add this item. Please try again.'); }
    finally { button.disabled = false; button.removeAttribute('aria-busy'); }
  }
  function close() {
    if (!active) return;
    const previous = active;
    active = null;
    previous.modal.remove();
    document.body.style.overflow = previous.overflow;
    if (previous.opener.isConnected) previous.opener.focus({ preventScroll: true });
  }
  function open(button) {
    const card = button.closest('[data-nsc-card]');
    const template = card?.querySelector('template[data-nsc-modal]');
    if (!template) return;
    close();
    const fragment = template.content.cloneNode(true);
    const modal = fragment.querySelector('[data-nsc-quickview]');
    if (!modal) return;
    let variants;
    try { variants = JSON.parse(fragment.querySelector('[data-nsc-qv-variants]').textContent); } catch { status(card, 'Quick view could not load. Please open the product.'); return; }
    active = { modal, opener: button, overflow: document.body.style.overflow };
    // Only the active modal enters the live DOM, outside the Hub search form.
    document.body.append(modal);
    modal.hidden = false;
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    const images = [...modal.querySelectorAll('.nsc-quickview__image')];
    let index = 0;
    function showImage(next) {
      if (!images.length) return;
      index = (next + images.length) % images.length;
      images.forEach((im, i) => im.classList.toggle('is-active', i === index));
    }
    showImage(0);
    const input = modal.querySelector('[data-nsc-qv-variant-input]');
    const cart = modal.querySelector('[data-nsc-qv-add-to-cart]');
    const groups = [...modal.querySelectorAll('[data-nsc-qv-option-index]')];
    function update() {
      const selected = groups.map(g => g.querySelector('.is-active')?.dataset.nscQvOptionValue);
      const variant = variants.find(v => v.options.every((o, i) => o === selected[i]));
      input.value = variant?.id || '';
      cart.disabled = !variant?.available;
      modal.querySelector('[data-nsc-qv-add-to-cart-text]').textContent = variant ? (variant.available ? modal.dataset.addToCartLabel : modal.dataset.soldOutLabel) : 'Unavailable';
      if (variant) {
        modal.querySelector('[data-nsc-qv-price-current]').innerHTML = variant.price;
        let compare = modal.querySelector('[data-nsc-qv-price-compare]');
        if (!compare) { compare = document.createElement('span'); compare.className = 'nsc-quickview__price-compare'; compare.dataset.nscQvPriceCompare = ''; modal.querySelector('[data-nsc-qv-price]').append(compare); }
        compare.innerHTML = variant.comparePrice || '';
        compare.hidden = !variant.comparePrice;
        if (Number.isInteger(variant.imageIndex)) showImage(variant.imageIndex);
      }
      groups.forEach(g => g.querySelectorAll('[data-nsc-qv-option-value]').forEach(b => b.setAttribute('aria-pressed', String(b.classList.contains('is-active')))));
    }
    update();
    modal.addEventListener('click', event => {
      event.stopPropagation();
      const target = event.target;
      if (target.closest('[data-nsc-quickview-close]')) { event.preventDefault(); close(); return; }
      if (target.closest('[data-nsc-qv-prev]')) showImage(index - 1);
      if (target.closest('[data-nsc-qv-next]')) showImage(index + 1);
      const option = target.closest('[data-nsc-qv-option-value]');
      if (option) {
        const group = option.closest('[data-nsc-qv-option-index]');
        group.querySelectorAll('[data-nsc-qv-option-value]').forEach(b => b.classList.toggle('is-active', b === option));
        group.querySelector('[data-nsc-qv-option-selected]').textContent = option.dataset.nscQvOptionValue;
        update();
      }
    });
    modal.querySelector('form').addEventListener('submit', event => { event.preventDefault(); event.stopPropagation(); add(cart, input.value, modal); });
    modal.querySelector('[data-nsc-quickview-close] button, button[data-nsc-quickview-close]')?.focus({ preventScroll: true });
  }
  function closeMenus(except) {
    document.querySelectorAll('[data-nsc-more-menu].is-open').forEach(menu => {
      if (menu === except) return;
      menu.hidden = true;
      menu.classList.remove('is-open');
      menu.closest('[data-nsc-card]')?.querySelector('[data-nsc-more-toggle]')?.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('pointerdown', event => {
    const inside = event.target.closest('[data-nsc-more-menu], [data-nsc-more-toggle]');
    if (!inside) closeMenus();
  }, true);
  // Capture handles only our explicit card actions, never header/menu controls.
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-nsc-wishlist-toggle], [data-nsc-quickview-open], [data-nsc-add-to-cart], [data-nsc-more-toggle]');
    if (!button) { if (!event.target.closest('[data-nsc-more-menu]')) closeMenus(); return; }
    if (!button.hasAttribute('data-nsc-more-toggle')) closeMenus();
    event.preventDefault(); event.stopImmediatePropagation();
    const card = button.closest('[data-nsc-card]') || button.closest('article') || button.parentElement;
    if (button.hasAttribute('data-nsc-wishlist-toggle')) {
      const id = button.dataset.productId;
      const ids = wishlist();
      const next = ids.includes(id) ? ids.filter(x => x !== id) : [...ids, id];
      try { localStorage.setItem(KEY, JSON.stringify(next)); }
      catch { status(card, 'Your browser could not save the wishlist. Please allow site storage.'); return; }
      sync(); document.dispatchEvent(new CustomEvent('wishlist:updated'));
    } else if (button.hasAttribute('data-nsc-quickview-open')) open(button);
    else if (button.hasAttribute('data-nsc-add-to-cart')) add(button, button.dataset.variantId, card);
    else {
      const menu = card.querySelector('[data-nsc-more-menu]');
      if (menu) { const expanded = menu.hidden; closeMenus(menu); menu.hidden = !expanded; menu.classList.toggle('is-open', expanded); button.setAttribute('aria-expanded', String(expanded)); }
    }
  }, true);
  document.addEventListener('keydown', event => {
    if (!active && event.key === 'Escape' && document.querySelector('[data-nsc-more-menu].is-open')) {
      event.preventDefault(); event.stopImmediatePropagation(); closeMenus(); return;
    }
    if (!active) return;
    // Escape belongs exclusively to the top modal; never let it reset search.
    if (event.key === 'Escape') { event.preventDefault(); event.stopImmediatePropagation(); close(); return; }
    if (event.key === 'Tab') {
      const list = [...active.modal.querySelectorAll('button:not([disabled]), a[href], input:not([type="hidden"]):not([disabled]), [tabindex="0"]')].filter(el => !el.hidden && el.getClientRects().length);
      const first = list[0], last = list[list.length - 1];
      if (first && (event.shiftKey ? document.activeElement === first || !active.modal.contains(document.activeElement) : document.activeElement === last || !active.modal.contains(document.activeElement))) { event.preventDefault(); (event.shiftKey ? last : first).focus(); }
    }
  }, true);
  document.addEventListener('wishlist:updated', sync);
  window.addEventListener('storage', event => { if (event.key === KEY) sync(); });
  let wishlistFrame = 0;
  new MutationObserver(records => {
    if (wishlistFrame || !records.some(record => [...record.addedNodes].some(node =>
      node.nodeType === 1 && (node.matches('[data-nsc-wishlist-toggle]') || node.querySelector('[data-nsc-wishlist-toggle]'))
    ))) return;
    wishlistFrame = requestAnimationFrame(() => { wishlistFrame = 0; sync(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  sync();
})();


(() => {
  if (window.nwMobileCardFit) return;
  window.nwMobileCardFit = true;
  const mobile = matchMedia('(max-width:749px)');
  const tracked = new Set();
  let frame = 0;
  const selector = '.nsc-card-shell,.dg-card-shell,.hmp-card-shell';
  function fit() {
    frame = 0;
    tracked.forEach(shell => {
      if (!shell.isConnected) { observer.unobserve(shell); tracked.delete(shell); return; }
      const card = shell.querySelector('.nsc-card,.dg-card,.hmp-card');
      if (!card) return;
      const width = shell.clientWidth;
      const scale = mobile.matches && shell.matches('.nsc-card-shell') && shell.closest('.header-search-row__predictive.is-search-hub-open') && width > 0;
      if (scale) {
        const base = Math.max(240, width);
        card.style.setProperty('--nw-card-base-width', base + 'px');
        card.style.setProperty('--nw-card-fit', String(width / base));
      } else {
        card.style.removeProperty('--nw-card-base-width');
        card.style.removeProperty('--nw-card-fit');
      }
      const price = card.querySelector('.nsc-card__price,.dg-card__price,.hmp-card__price');
      const current = price?.querySelector('.nsc-card__price-current,.dg-card__price-current,.hmp-card__price-current');
      if (!price || !current) return;
      price.style.removeProperty('--nw-mobile-price-size');
      if (!mobile.matches || !width) return;
      const available = price.clientWidth;
      const needed = current.scrollWidth;
      if (available > 0 && needed > available) {
        const size = parseFloat(getComputedStyle(current).fontSize);
        price.style.setProperty('--nw-mobile-price-size', (size * available / needed) + 'px');
      }
    });
  }
  function queue() { if (!frame) frame = requestAnimationFrame(fit); }
  const observer = new ResizeObserver(queue);
  function discover(root = document) {
    const shells = root.matches?.(selector) ? [root] : root.querySelectorAll?.(selector) || [];
    let added = false;
    shells.forEach(shell => {
      if (!tracked.has(shell)) { tracked.add(shell); observer.observe(shell); added = true; }
    });
    if (added) queue();
  }
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') {
        if (record.target.matches('.header-search-row__predictive')) queue();
        continue;
      }
      for (const node of record.addedNodes) if (node.nodeType === 1) discover(node);
      if (record.target.closest?.('.nsc-card__price,.dg-card__price,.hmp-card__price')) queue();
    }
  }).observe(document.documentElement, {childList:true,subtree:true,attributes:true,attributeFilter:['class']});
  mobile.addEventListener('change', queue);
  window.addEventListener('resize', queue);
  document.fonts?.ready.then(queue);
  discover();
})();

